function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 141,
    viewBox: "0 0 140 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13781_181229)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13781_181229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 141
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 0.463135H0V140.463H140V0.463135Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1738 121.322C21.6799 121.322 22.9082 120.094 22.9082 118.588C22.9082 117.082 21.6799 115.854 20.1738 115.854C18.6677 115.854 17.4395 117.082 17.4395 118.588C17.4395 120.094 18.6677 121.322 20.1738 121.322Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.826 25.0735C121.333 25.0735 122.561 23.8452 122.561 22.3391C122.561 20.833 121.333 19.6047 119.826 19.6047C118.32 19.6047 117.092 20.833 117.092 22.3391C117.092 23.8452 118.32 25.0735 119.826 25.0735Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13781_181229)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13781_181229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 141
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.464859H140V140.465H0V0.464859Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13781_181229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 129.526V137.729H91.3841L119.826 109.287V33.2767M119.826 11.4017V3.198H20.1738V107.651",
    stroke: "#B3C0BD",
    style: {
      stroke: "#B3C0BD",
      stroke: "color(display-p3 0.7020 0.7529 0.7412)",
      strokeOpacity: 1
    },
    strokeWidth: 5.46875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3828 137.729V109.286H119.826L91.3828 137.729Z",
    stroke: "#B3C0BD",
    style: {
      stroke: "#B3C0BD",
      stroke: "color(display-p3 0.7020 0.7529 0.7412)",
      strokeOpacity: 1
    },
    strokeWidth: 5.46875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4883 48.1336L57.7135 31.9081M82.2882 48.1336L98.5137 31.9081M57.7135 48.1336L41.4883 31.9081M98.5137 48.1336L82.2882 31.9081M98.5137 82.7686C91.4371 77.0668 81.2825 73.4936 70.0007 73.4936C58.7195 73.4936 48.5648 77.0668 41.4883 82.7683",
    stroke: "#B3C0BD",
    style: {
      stroke: "#B3C0BD",
      stroke: "color(display-p3 0.7020 0.7529 0.7412)",
      strokeOpacity: 1
    },
    strokeWidth: 5.46875,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1738 121.322C21.6799 121.322 22.9082 120.093 22.9082 118.587C22.9082 117.081 21.6799 115.853 20.1738 115.853C18.6677 115.853 17.4395 117.081 17.4395 118.587C17.4395 120.093 18.6677 121.322 20.1738 121.322Z",
    fill: "#B3C0BD",
    style: {
      fill: "#B3C0BD",
      fill: "color(display-p3 0.7020 0.7529 0.7412)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.826 25.0732C121.333 25.0732 122.561 23.845 122.561 22.3389C122.561 20.8328 121.333 19.6045 119.826 19.6045C118.32 19.6045 117.092 20.8328 117.092 22.3389C117.092 23.845 118.32 25.0732 119.826 25.0732Z",
    fill: "#B3C0BD",
    style: {
      fill: "#B3C0BD",
      fill: "color(display-p3 0.7020 0.7529 0.7412)",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13781_181229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0 0.463867)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.1c2fed7c61c1d06bb473bb98132f8789.svg";
export { ForwardRef as ReactComponent };